import { render } from "./ThemeTestPage.vue?vue&type=template&id=99525da2"
import script from "./ThemeTestPage.vue?vue&type=script&lang=js"
export * from "./ThemeTestPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__